import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import clientErrors from './client-errors'
import loginDf2c2a from './login'
import password from './password'
import invitations from './invitations'
import mfa from './mfa'
import staff from './staff'
import customers from './customers'
import feedback from './feedback'
import finance from './finance'
import operations from './operations'
import content from './content'
import taxonomy from './taxonomy'
import media from './media'
import support from './support'
import roles from './roles'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
export const entry = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: entry.url(options),
    method: 'get',
})

entry.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
entry.url = (options?: RouteQueryOptions) => {
    return entry.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
entry.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: entry.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
entry.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: entry.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
const entryForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: entry.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
entryForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: entry.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::entry
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:19
* @route 'https://org.proexpert.app'
*/
entryForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: entry.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

entry.form = entryForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::login
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:24
* @route 'https://org.proexpert.app/org/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::logout
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:65
* @route 'https://org.proexpert.app/org/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::logout
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:65
* @route 'https://org.proexpert.app/org/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::logout
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:65
* @route 'https://org.proexpert.app/org/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::logout
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:65
* @route 'https://org.proexpert.app/org/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::logout
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:65
* @route 'https://org.proexpert.app/org/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
export const today = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: today.url(options),
    method: 'get',
})

today.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/today',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
today.url = (options?: RouteQueryOptions) => {
    return today.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
today.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: today.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
today.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: today.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
const todayForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: today.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
todayForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: today.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgTodayController::today
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgTodayController.php:19
* @route 'https://org.proexpert.app/org/today'
*/
todayForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: today.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

today.form = todayForm

const org = {
    clientErrors: Object.assign(clientErrors, clientErrors),
    entry: Object.assign(entry, entry),
    login: Object.assign(login, loginDf2c2a),
    password: Object.assign(password, password),
    invitations: Object.assign(invitations, invitations),
    logout: Object.assign(logout, logout),
    mfa: Object.assign(mfa, mfa),
    today: Object.assign(today, today),
    staff: Object.assign(staff, staff),
    customers: Object.assign(customers, customers),
    feedback: Object.assign(feedback, feedback),
    finance: Object.assign(finance, finance),
    operations: Object.assign(operations, operations),
    content: Object.assign(content, content),
    taxonomy: Object.assign(taxonomy, taxonomy),
    media: Object.assign(media, media),
    support: Object.assign(support, support),
    roles: Object.assign(roles, roles),
}

export default org